import { render, staticRenderFns } from "./jianchadan.vue?vue&type=template&id=edee8c44"
import script from "./jianchadan.vue?vue&type=script&lang=js"
export * from "./jianchadan.vue?vue&type=script&lang=js"
import style0 from "./jianchadan.vue?vue&type=style&index=0&id=edee8c44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports